import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: theme.fontFamily,
    fontSize: '0.875rem',
    boxSizing: 'border-box',
    lineHeight: 1.5,
    border: theme.border,
    borderRadius: 4,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    background: theme.backgroundColor,
    width: 48,
    height: 48,
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    // a disabled button (e.g. "-" at the minimum) neither reacts nor shows a pointer
    '@media (hover: hover)': {
      '&:hover:not(:disabled)': {
        cursor: 'pointer',
        background: theme.primaryV2,
        color: theme.white,
      },
    },
    '@media (hover: none)': {
      '&:active': {
        background: theme.primaryV2,
        color: theme.white,
        transform: 'scale(0.95)',
      },
    },
    '&:focus-visible': {
      outline: 0,
    },
    '&:disabled': {
      background: theme.white,
      color: theme.fontColors.secondary,
    },
  },
  increment: {
    order: 1,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
}))

interface IQuantityActionButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  increment?: boolean
  children?: React.ReactNode
}

const QuantityActionButton: React.FC<IQuantityActionButton> = ({ increment, children, className, ...props }) => {
  const classes = useStyles()
  return (
    <button
      className={clsx(classes.root, increment && classes.increment, className)}
      {...props}
    >
      {children}
    </button>
  )
}

export default QuantityActionButton
